import dayjs from "dayjs";

const properties = {
  colors: {
    Blue: "#1E83C8",
    AshGray: "#797C7B",
    CharcoalGray: "#424242",
    White: "#FFFFFF",
    Black: "#000000",
    JetBlack: "#232323",
    Red: "#ED1C24",
    DarkSlateBlue: "#333B69",
    GraniteGray: "#525252",
    CharcoalBrown: "#555250",
    Orange: "#EA8A14",
    BrightOrange: "#EF7D00",
    LightGray: "#C4C4C4",
    MediumBlue: "#1E83C8",
    AquaTeal: "#2FA4A2",
    DarkGrey: "#555250",
    bgcolorbluethem: "linear-gradient(to bottom, #53B0E0, #2D2EAA) !important"
  },
  fontFamily: "Manrope, sans-serif"
};

export const formatDesignation = designation => {
  if (!designation) return "N/A";

  if (designation === "manager_hr") {
    return "Manager - HR";
  } else if (designation === "hr_executive") {
    return "HR Executive";
  } else if (designation === "it_engineer") {
    return "IT Engineer";
  } else if (designation === "qa_lead") {
    return "QA Lead";
  }

  return designation
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());
};

export const formatEmployeeName = name => {
  if (!name) return "N/A";
  const parts = name.trim().split(" ");
  if (parts.length > 1) {
    const title = parts[0].toLowerCase();
    let formattedTitle = title;
    if (title === "mr.") {
      formattedTitle = "Mr.";
    } else if (title === "ms.") {
      formattedTitle = "Ms.";
    } else if (title === "mrs.") {
      formattedTitle = "Mrs.";
    }
    return `${formattedTitle} ${parts.slice(1).join(" ")}`;
  }
  return name;
};

export function formatDate(dateString) {
  if (!dateString) return "-";
  const date = dayjs(dateString);
  return date.isValid() ? date.format("DD MMM YYYY") : " - ";
}

export const toBackendDesignationFormat = designation => {
  if (!designation || !designation.trim()) return "";
  return designation.trim().toLowerCase().replace(/\s+/g, "_");
};

export const formatEducation = (education, educationOther) => {
  if (!education) return "";

  if (education === "Other") {
    return educationOther || "";
  }

  if (education === "post_graduate") {
    return "Post Graduate";
  } else if (education === "graduate") {
    return "Graduate";
  }
  return education;
};

export const formatType = type => {
  if (!type) return "";

  return type
    .split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join("-");
};

export default properties;
